import React, { useState } from "react";
import Contacts from "@/pages/contacts";
const Canadaskilledmigrationvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
      <div className="relative w-full h-auto">
  {/* Image Section */}
  <img
    src="/cannads.jpg" // Replace with the correct path to your image
    alt="Canada Immigration"
    className="w-full h-auto md:h-96 object-cover"
  />
  {/* Text Overlay */}
  
</div>

      </div>
      <div className="mt-10 mx-5 md:mx-32 text-xl sm:text-2xl md:text-3xl font-bold text-[#011473] drop-shadow-md">
  Federal Skilled Worker Requirements and Documentation for Canada Immigration:
</div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-8">
        {/* Left Section: Image */}

        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/skilleds.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-4 lg:w-1/2">
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Valid Passport – At least six months of validity.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Language Proficiency Results – IELTS/CELPIP for English, TEF/TCF
              for French.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Educational Credential Assessment (ECA) – From WES, ICAS, or IQAS.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Work Experience Proof – Reference letters, contracts, pay stubs.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Proof of Funds – Bank statements to demonstrate financial support.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Medical Report – From an approved physician.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Police Clearance – Certificates from countries lived in for 6+
              months since 18.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Family Documents – Birth/marriage/adoption certificates (if
              applicable).
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Provincial Nomination – If applicable.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Job Offer Letter – If applicable.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Passport-sized Photos – As per IRCC guidelines.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Payment Receipts – For visa fees.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Express Entry Profile Number – If applicable.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Travel History – Record of international travel in the last 10
              years.
            </span>
          </div>
        </div>
      </div>
      <div className="px-8 py-12 md:py-20">
      <p className="mb-20  md:ml-32 w-full md:w-2/3 text-center text-xl sm:text-2xl md:text-3xl font-bold text-[#011473]">
      Advantages of a Canada Permanent Resident Visa
</p>
  <div className="2xl:px-52 2xl:space-y-10 space-y-10 md:grid md:grid-cols-2 md:gap-10 md:space-y-0 lg:grid lg:grid-cols-3 lg:gap-8 lg:space-y-0 lg:px-10 xl:grid xl:grid-cols-3 xl:gap-10 xl:space-y-0 xl:px-10">
    {[
      {
        href: "#", // Update this if needed
        title: "Healthcare",
        description:
          "Access to provincial health coverage after three months.",
        imgSrc: "/turist.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Education",
        description: "Free public education until age 18.",
        imgSrc: "/bussines.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Canada Child Tax Benefit",
        description:
          "Monthly payments for low-income families with children under 18.",
        imgSrc: "/visits.JPG",
      },
      {
        href: "#", // Update this if needed
        title: "Parental Leave",
        description:
          "Paid leave for parents, with up to 12 months off and 65% income support for mothers.",
        imgSrc: "/medical.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Taxation",
        description: "No taxes on foreign income.",
        imgSrc: "/studentmedical.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Social Services",
        description:
          "Access to pensions, subsidized housing, and job training programs.",
        imgSrc: "/stay.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Pathway to Citizenship",
        description:
          "Eligibility for Canadian citizenship after 1095 days of residence.",
        imgSrc: "/passports.jpg",
      },
      {
        href: "#", // Update this if needed
        title: "Transit Visa",
        description:
          "This visa allows travelers passing through Denmark on their way to another destination. It is valid for stays from 1 to 90 days.",
        imgSrc: "/transit.JPG",
      },
      {
        href: "#", // Update this if needed
        title: "Investor Visa",
        description:
          "Opportunities for entrepreneurs and investors to immigrate and bring their families to Canada.",
        imgSrc: "/air.jpg",
      },
    ].map((resource, index) => (
      <div
        key={index}
        data-aos="fade-up"
        className="2xl:w-[400px] 2xl:mt-9 group relative h-auto w-80 overflow-hidden rounded-3xl border border-black font-sans hover:shadow-lg"
      >
        <a href={resource.href} className="block">
          <div className="px-2 py-2">
            <div className="2xl:w-[380px] 2xl:h-[250px] relative h-[190px] w-[300px] overflow-hidden rounded-2xl">
              <img
                src={resource.imgSrc}
                alt={resource.title}
                className="absolute left-0 top-0 object-cover transition-transform duration-500 group-hover:scale-110"
              />
            </div>
          </div>
          <div className="p-8">
            <h3 className="font-syne mb-2 text-[20px] font-medium text-[#011473]">
              {resource.title}
            </h3>
            <p className="text-sm font-medium text-black">
              {resource.description}
            </p>
          </div>
        </a>
      </div>
    ))}
  </div>
</div>

      <p className="mb-5  md:ml-32 w-full md:w-2/3 text-left text-xl sm:text-2xl md:text-3xl font-bold text-[#011473]">
  Canada offers several business immigration pathways that lead to permanent residency. These include:
</p>

<div className="ml-5 md:ml-32 items-center justify-center space-y-4 md:space-y-6">
  <div className="flex items-center space-x-3 md:space-x-5">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="font-medium text-gray-700 text-sm md:text-base">
      Quebec Immigrant Investor Program (QIIP)
    </span>
  </div>

  <div className="flex items-center space-x-3 md:space-x-5">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="font-medium text-gray-700 text-sm md:text-base">
      Quebec Entrepreneur Program
    </span>
  </div>

  <div className="flex items-center space-x-3 md:space-x-5">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="font-medium text-gray-700 text-sm md:text-base">
      Quebec Self-Employed Program
    </span>
  </div>

  <div className="flex items-center space-x-3 md:space-x-5">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="font-medium text-gray-700 text-sm md:text-base">
      Provincial Nominee Entrepreneur Programs
    </span>
  </div>

  <div className="flex items-center space-x-3 md:space-x-5">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="font-medium text-gray-700 text-sm md:text-base">
      Federal Immigrant Investor Program
    </span>
  </div>

  <div className="flex items-center space-x-3 md:space-x-5">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="font-medium text-gray-700 text-sm md:text-base">
      Federal Start-Up Visa Program
    </span>
  </div>
</div>

<div className="flex w-full flex-col items-center justify-center py-20">
  {isOpen && (
    <div className="mb-6 w-3/4 items-center justify-center text-black rounded-md bg-gray-100 p-4 text-lg shadow-md">
      <p>
        <br />
        - <strong>Overview of Canada’s Immigration Program:</strong> Canada, consisting of 10 provinces and 3 territories, is known for its dynamic approach towards skilled immigration. The Federal Skilled Worker Program (FSWP) offers skilled professionals across various sectors the opportunity to immigrate to Canada and secure permanent residence.
        <br />
        - <strong>Support for Global Talent:</strong> Canada welcomes individuals with diverse skills, contributing to its economic, intellectual and cultural growth. The country’s commitment to attracting global talent has helped enhance its workforce and drive innovation.
        <br />
        - <strong>Federal Skilled Worker Program (FSWP) Under Express Entry:</strong> Since 2008, the FSWP has been a key part of Canada’s Express Entry System, designed to fast-track immigration for skilled workers. The program targets professionals with recognized qualifications, work experience, language proficiency and other essential factors for immigration.
        <br />
        - <strong>Eligibility Criteria for FSWP:</strong> Candidates must meet specific criteria including education, work experience, language proficiency and age. Applicants need to score at least 67 points out of 100 based on these factors.
        <br />
        - <strong>Expression of Interest System:</strong> Candidates can enter the Expression of Interest (EOI) system, where they are ranked according to factors such as age, qualifications, work experience and language skills. The highest-ranked candidates are then invited to apply for permanent residence.
        <br />
        - <strong>Benefits for Skilled Workers:</strong> The Federal Skilled Worker Program provides a significant opportunity for experienced professionals to gain permanent residency in Canada. By fulfilling the program’s requirements, candidates can contribute to Canada's growth and integration within its diverse workforce.
        <br />
        - <strong>Streamlining the Process:</strong> Hiring expert immigration consultants can simplify and expedite the application process, ensuring that all necessary documentation and procedures are followed efficiently.
        <br />
      </p>
    </div>
  )}
  <button
    onClick={toggleAnswer}
    className="flex w-2/2 md:w-1/2 items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
  >
    Canada Skilled Immigration – Federal Skilled Worker Program (FSWP)
    <svg
      className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${
        isOpen ? "rotate-180" : ""
      }`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M12 5v14M5 12l7 7 7-7"></path>
    </svg>
  </button>
</div>


      |
      <Contacts />
    </>
  );
};

export default Canadaskilledmigrationvisa;
